import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["toggle", "panel"]

  connect() {
    this.closeBeforeCache = () => this.close()
    document.addEventListener("turbo:before-cache", this.closeBeforeCache)
    this.close()
  }

  disconnect() {
    document.removeEventListener("turbo:before-cache", this.closeBeforeCache)
  }

  toggle(event) {
    event.preventDefault()

    if (this.isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  closeFromOutside(event) {
    if (!this.element.contains(event.target)) this.close()
  }

  open() {
    this.element.classList.add("is-menu-open")
    this.toggleTarget.setAttribute("aria-expanded", "true")
    this.toggleTarget.setAttribute("aria-label", "メニューを閉じる")
    this.panelTarget.setAttribute("aria-hidden", "false")
    this.panelTarget.inert = false
  }

  close() {
    if (!this.hasToggleTarget || !this.hasPanelTarget) return

    this.element.classList.remove("is-menu-open")
    this.toggleTarget.setAttribute("aria-expanded", "false")
    this.toggleTarget.setAttribute("aria-label", "メニューを開く")
    this.panelTarget.setAttribute("aria-hidden", "true")
    this.panelTarget.inert = true
  }

  get isOpen() {
    return this.element.classList.contains("is-menu-open")
  }
}
